function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getLongTaskQueue, clearLongTaskQueue, TBTTimeout } from "./longtask";
import { sendAsyncMetric } from "./index";
import { onFCP } from "../../../utils/web-vitals";
import { _requestIdleCallback } from "../../utils";

// TTI: Time to Interactive （可交互时间）
// 主线程 5s 空闲则代表 TTI 。 空闲指没有 longtask。
/*
1. 从第一次有内容的绘制 First Contentful Paint (FCP) 开始计算。
2. 从前往后查找一个静默 5s 的安静窗口，安静窗口指得是：没有 Long Task。
3. 从后往前查找静默窗口之前的最后一个长任务的结束时间，如果找不到长任务，则停止在 FCP 处停止。
4. TTI 是安静窗口之前的最后一个长任务的结束时间（如果未找到长任务，则与 FCP 值相同）。
*/

var checkDurationThreshold = 5e3; // 5s 空闲则代表 TTI
var idleTimeThreshold = 50 + 3; // 2ms 误差, 实际测试发现即使空白页面中没有longtask 也会出现51 52ms的波动

export var startTTI_TTB = function startTTI_TTB(task) {
  return new Promise(function (resolve) {
    onFCP(function (entry) {
      // requestIdleCallback 
      var fcp = entry.value; //  不能用 performance.now()
      // 有个坑 发现 onFCP 回调时的 performance.now() 与 entry.value 不相同，需要用 entry.value 作为 TTI
      var TTI = fcp; // 默认等于 fcp, 
      var totalStartTime = Date.now(); // fcp 起始时间
      var startTime = Date.now(); // 
      // let count = 0
      // console.log('idle', count, startTime)
      // console.log('fcp entry TTI totalStartTime', entry, TTI, totalStartTime)

      var callback = function callback() {
        // count++
        var duration = Date.now() - startTime;
        if (duration > idleTimeThreshold) {
          totalStartTime = Date.now();
          TTI = performance.now();
          // count = 0
          // console.log('idle duration > idleTimeThreshold TTI', duration, idleTimeThreshold, TTI)
        }
        var totalDuration = Date.now() - totalStartTime;
        // console.log('idle count duration totalDuration totalStartTime', count, duration, totalDuration, totalStartTime)
        startTime = Date.now();
        if (totalDuration > checkDurationThreshold) {
          var TBT = calcTBTByTasks(getLongTaskQueue(), TTI);
          clearLongTaskQueue();
          sendAsyncMetric(task, {
            type: 'tbt',
            value: TBT
          });
          resolve({
            TTI: TTI,
            TBT: TBT
          });
          // console.log('TTI idle end checking', { TTI, TBT }, totalDuration)
          return;
        }
        if (performance.now() > TBTTimeout) {
          TTI = TBTTimeout;
          var _TBT = calcTBTByTasks(getLongTaskQueue(), TTI);
          clearLongTaskQueue();
          sendAsyncMetric(task, {
            type: 'tbt',
            value: _TBT
          });
          resolve({
            TTI: TTI,
            TBT: _TBT
          });
          // console.log('TTI idle end timeout', { TTI, TBT }, totalDuration)
          return;
        }
        _requestIdleCallback(function () {
          callback();
        });
      };
      // 
      _requestIdleCallback(callback);
    });
  });
};

// TBT:  截止到 TTI 的所有长任务 duration - 50
var calcTBTByTasks = function calcTBTByTasks() {
  var longtasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var TTI = arguments.length > 1 ? arguments[1] : undefined;
  var acc = 0;
  var _iterator = _createForOfIteratorHelper(longtasks),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.startTime < TTI) {
        acc += item.duration - 50;
      } else {
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return acc;
};